import React, { PropsWithChildren } from 'react'
import classes from './Table.module.scss'
import clsx from 'clsx'

export type RowProps = PropsWithChildren<{
  onClick?: React.MouseEventHandler<HTMLDivElement>
}>

const Row = ({ onClick, children }: RowProps) => {
  const className = clsx(classes.row, {
    [classes.clickable]: !!onClick,
  })

  return (
    <div className={className} onAuxClick={onClick} onClick={onClick} role={'button'} tabIndex={0}>
      {children}
    </div>
  )
}

export default Row
